import React, { memo, useEffect, useMemo, useState } from "react";
import {
  sanitizeVisualState,
} from "./visualAtmosphere";

const VISUAL_MAP = Object.freeze({
  DEFAULT: "/videos/videos%20com%20som/default%20limpo.mp4",
  PARABLE: "/videos/videos%20com%20som/parabolico%20mais%20nevoa.mp4",
  TENSION: "/videos/videos%20com%20som/tensao%20nevoa%20menor.mp4",
  CRITICAL: "/videos/videos%20com%20som/critico%20raio.mp4",
});

function VHAtmosphereLayer({ visualState, backgroundMediaMode = "scene_static" }) {
  const hasVisualState = Boolean(visualState);
  const state = sanitizeVisualState(visualState || {});
  const videoSrc = hasVisualState ? VISUAL_MAP[state.mode] || VISUAL_MAP.DEFAULT : "";
  const [readySrc, setReadySrc] = useState("");

  useEffect(() => {
    setReadySrc("");
  }, [videoSrc]);

  const debugEnabled = useMemo(
    () =>
      process.env.NODE_ENV !== "production" &&
      typeof window !== "undefined" &&
      new URLSearchParams(window.location.search).get("vh_visual_debug") === "1",
    []
  );

  if (!hasVisualState) return null;

  return (
    <div
      className={`vh-atmosphere vh-atmosphere--${state.mode.toLowerCase()}`}
      data-visual-mode={state.mode}
      data-background-media={backgroundMediaMode}
      aria-hidden="true"
    >
      <video
        key={videoSrc}
        className={`vh-atmosphere__video ${readySrc === videoSrc ? "vh-atmosphere__video--ready" : ""}`}
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        onLoadedData={() => setReadySrc(videoSrc)}
        onError={() => setReadySrc("")}
      />
      {debugEnabled ? (
        <div className="vh-atmosphere__debug">
          {state.mode} - {backgroundMediaMode}
        </div>
      ) : null}
    </div>
  );
}

export default memo(VHAtmosphereLayer);
